"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var classNames = require('classnames');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var IconButton = require('../iconButton/iconButton.js');

var HelpIcon = require('../../panels/headerHelp-svg.js');

var CloseIcon = require('../../panels/headerCloseButton.svg.js');

var _require = require('./constants'),
    dataHooks = _require.dataHooks;

var BaseModalHeader = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BaseModalHeader, _React$PureComponent);

  var _super = _createSuper(BaseModalHeader);

  function BaseModalHeader() {
    _classCallCheck(this, BaseModalHeader);

    return _super.apply(this, arguments);
  }

  _createClass(BaseModalHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          onCloseButtonClick = _this$props.onCloseButtonClick,
          onHelpButtonClick = _this$props.onHelpButtonClick; // TODO: change icons #EK-2177

      return /*#__PURE__*/React.createElement("div", {
        className: classNames('control-base-modal-header', className)
      }, children, /*#__PURE__*/React.createElement("div", {
        className: "control-base-modal-header-btn-bar"
      }, onHelpButtonClick && /*#__PURE__*/React.createElement(IconButton, {
        skin: "light-dark",
        className: "control-base-modal-header-btn control-base-modal-header-btn-help",
        onClick: onHelpButtonClick,
        dataHook: dataHooks.helpButton
      }, /*#__PURE__*/React.createElement(HelpIcon, null)), onCloseButtonClick && /*#__PURE__*/React.createElement(IconButton, {
        skin: "light-dark",
        className: "control-base-modal-header-btn control-base-modal-header-btn-close",
        onClick: onCloseButtonClick,
        dataHook: dataHooks.closeButton
      }, /*#__PURE__*/React.createElement(CloseIcon, null))));
    }
  }]);

  return BaseModalHeader;
}(React.PureComponent);

BaseModalHeader.displayName = displayNames.BASE_MODAL_HEADER;
BaseModalHeader.propTypes = {
  /** A css class to be applied to the component's root element */
  className: PropTypes.string,

  /** callback for when the close button is clicked */
  onCloseButtonClick: PropTypes.func,

  /** callback for when the help button is clicked */
  onHelpButtonClick: PropTypes.func
};
BaseModalHeader.defaultProps = {};
module.exports = compose(BaseModalHeader);